import angular from 'angular';
import fineTunePostsComponent from './fineTunePostsComponent';
import FineTunePostsService from './FineTunePostsService';
import 'components/sharpr/scrollManager/scrollManagerModule';
import 'components/sharpr/eventTracker/eventTrackerModule';
import 'components/sharpr/url/data/urlDataModule';
import 'components/sharpr/api/apiModule';
import 'components/sharpr/taxonomy/taxonomyModule';
import 'components/sharpr/savedSearches/savedSearchesModule';
import 'components/sharpr/collapsible/collapsibleModule';
import 'components/sharpr/filterMessage/filterMessageModule';
import 'components/sharpr/clearableInput/clearableInputModule';
import 'components/sharpr/identity/identityModule';
import 'components/sharpr/date/dateRangePicker/dateRangePickerModule';
import 'components/sharpr/fineTune/checkboxes/fineTuneCheckboxesModule';

angular
	.module('sh.fineTunePosts', [
		'sh.scrollManager',
		'sh.eventTracker',
		'sh.urlData',
		'sh.api',
		'sh.taxonomy',
		'sh.savedSearches',
		'sh.collapsible',
		'sh.filterMessage',
		'sh.clearableInput',
		'sh.identity',
		'sh.dateRangePicker',
		'sh.fineTuneCheckboxes',
	])
	.component('shFineTunePosts', fineTunePostsComponent())
	.service('FineTunePosts', FineTunePostsService);
